export default __webpack_public_path__ + "static/media/Dental.5a27a647.png";